import { define, type, auto } from 'type-r';
import Collection, {Record} from './base'
import MenuItem from './menu_item'

@define
export class MenuCollection<R extends Menu = Menu> extends Collection<R> {
}

@define
export default class Menu extends Record {
    static Collection = MenuCollection
    @type(MenuItem).as menu: MenuItem
    @type(Number).as productId: Number
    @type(Number).as qty: Number
    
}
